// extracted by mini-css-extract-plugin
export var actionIcon = "_oa-0";